import gql from 'graphql-tag'

export default gql`query getThePlaceSlides ($type: String!) {
  getThePlaceSlidesByType (type: $type) {
		id
		order
		type
		updated_at
		details {
			id
      title
			content
			language_code
		}
	}
}`



// WEBPACK FOOTER //
// ./src/apollo/graphql/thePlaceSlide/getSlides.js